import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { SvgIconModule } from '../svg-icon';

import { TimePickerComponent } from './time-picker.component';

@NgModule({
    declarations: [TimePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [TimePickerComponent]
})
export class TimePickerModule { }
